import { ActionStatus } from '../../../../common/constants/action-status';
import { StoreState } from '../../../../store/store.interface';

export const getApplePayInstanceStatus = (state: StoreState) => state.braintreeState.applePayInstance.status;

export const getApplePayInstance = (state: StoreState) => state.braintreeState.applePayInstance.data;

export const isApplePayEnabled = (state: StoreState) => !!state.shopCheckoutState.clientToken.data?.applePayEnabled;

export const isApplePayReadyToUse = (state: StoreState): boolean =>
state.braintreeState.applePayInstance.status === ActionStatus.succeeded
